import type { IconSvgObject } from './types';

const PresentationLineChart01Icon: IconSvgObject = [
  ["path", { d: "M21.5 14V5C21.5 3.34315 20.1569 2 18.5 2H5.5C3.84315 2 2.5 3.34315 2.5 5V14C2.5 15.6569 3.84315 17 5.5 17L18.5 17C20.1569 17 21.5 15.6569 21.5 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 10.2246L8.69655 9.31009C9.57522 8.15647 11.1291 8.24842 11.9058 9.49998C12.6564 10.7094 14.1427 10.8437 15.0402 9.78321L16 8.6491", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 17.5L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 22L12.0001 19L17 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PresentationLineChart01Icon;
